import {
  createFrontendModule,
  NavItemBlueprint,
} from '@backstage/frontend-plugin-api';
import { IconComponent } from '@backstage/core-plugin-api';
import { Code2 } from 'lucide-react';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';

// Create a custom api-docs navigation item with better icon
// IMPORTANT: No 'name' property to ensure ID matches the original 'nav-item:api-docs'
const customApiDocsNavItem = NavItemBlueprint.make({
  params: {
    title: 'APIs',
    icon: Code2 as IconComponent,
    routeRef: apiDocsPlugin.routes.root,
  },
});

// Apply override to replace the factory function
const customApiDocsNavExtension = customApiDocsNavItem.override({
  factory: (originalFactory, context) => {
    return originalFactory(context);
  },
});

// Create a module that contains our custom api-docs configurations
// Using 'api-docs' as pluginId since we're overriding api-docs plugin
export const customApiDocsModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [
    customApiDocsNavExtension, // Add the custom nav item with override
    // Add more api-docs customizations here later
  ],
});